//Threshold 2 days.
const DAYS_THRESHOLD = 86400000 * 2;

export const isAbleToMutateDailyPuzzle = (date: Date) => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const targetDate = new Date(date);
  targetDate.setHours(0, 0, 0, 0);
  return targetDate.getTime() - now.getTime() > DAYS_THRESHOLD;
};
